"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const payments_1 = require("../payments");
const utils_1 = require("@loadsure/utils");
const date_fns_1 = require("date-fns");
const supportData_1 = require("../supportData");
const address_1 = __importDefault(require("../address"));
const assured_1 = __importDefault(require("../assured"));
const certificateChange_1 = __importDefault(require("../certificateChange"));
const insuranceCoverage_1 = require("../insuranceCoverage/insuranceCoverage");
const partner_1 = __importStar(require("../partner"));
const payment_1 = __importDefault(require("../payments/payment"));
const shipment_1 = __importDefault(require("../shipment"));
const user_1 = __importDefault(require("../user"));
function getShipment(data) {
    if (data.version >= 2) {
        return shipment_1.default.fromObj(data.shipment);
    }
    return shipment_1.default.fromInsureLoadV1(data);
}
function getPayment(data) {
    var _a;
    if (data.version >= 2 || ((_a = data.payment) === null || _a === void 0 ? void 0 : _a.type)) {
        return payment_1.default.fromObj(data.payment);
    }
    if (data.partner.payByInvoice) {
        return new payments_1.InvoicePayment();
    }
    return payment_1.default.fromObj(data.cardInfo);
}
class InsuranceCertificate {
    constructor(partner, certificateNumber, purchasedDate, user, coverage, assured, shipment, payment, partnerIds, authorizedUsers, channel, sandbox, version, status, quoteId, purchaser, cancellationReason, cancellationAdditionalInfo, canceledBy, canceledDate, sanctionsChecks, underwriting, underwritingCoverageUpdates, changeHistory, accountId, claimAdjuster, invoicedDate) {
        this.partner = partner;
        this.certificateNumber = certificateNumber;
        this.purchasedDate = purchasedDate;
        this.user = user;
        this.coverage = coverage;
        this.assured = assured;
        this.shipment = shipment;
        this.payment = payment;
        this.partnerIds = partnerIds;
        this.authorizedUsers = authorizedUsers;
        this.channel = channel;
        this.sandbox = sandbox;
        this.version = version;
        this.status = status;
        this.quoteId = quoteId;
        this.purchaser = purchaser;
        this.cancellationReason = cancellationReason;
        this.cancellationAdditionalInfo = cancellationAdditionalInfo;
        this.canceledBy = canceledBy;
        this.canceledDate = canceledDate;
        this.sanctionsChecks = sanctionsChecks;
        this.underwriting = underwriting;
        this.underwritingCoverageUpdates = underwritingCoverageUpdates;
        this.changeHistory = changeHistory;
        this.accountId = accountId;
        this.claimAdjuster = claimAdjuster;
        this.invoicedDate = invoicedDate;
    }
    static fromObj(data) {
        var _a, _b, _c, _d, _e, _f;
        const partner = partner_1.default.fromObj(data.partner);
        const purchasedDate = _1.getPurchasedDate(data);
        const user = user_1.default.fromObj(data.user);
        const coverage = insuranceCoverage_1.getInsuranceCoverage(data);
        const assured = assured_1.default.fromObj((_b = (_a = data.assured) !== null && _a !== void 0 ? _a : data.shipment.assured) !== null && _b !== void 0 ? _b : data.certificateHolder);
        const shipment = getShipment(data);
        const payment = getPayment(data);
        const partnerIds = (_c = data.partnerIds) !== null && _c !== void 0 ? _c : [partner_1.PORTAL_PARTNER_ID, data.partner.id];
        const authorizedUsers = _1.getAuthorizedUsers(data);
        const sandbox = (_d = data.sandbox) !== null && _d !== void 0 ? _d : partner_1.isSandboxPartner(partner.id);
        const purchaser = data.purchaser ? user_1.default.fromObj(data.purchaser) : undefined;
        const changeHistory = data.changeHistory
            ? data.changeHistory.map(certificateChange_1.default.fromObj)
            : [];
        const version = (_e = data.version) !== null && _e !== void 0 ? _e : this.lastVersion;
        return new InsuranceCertificate(partner, data.certificateNumber, purchasedDate, user, coverage, assured, shipment, payment, partnerIds, authorizedUsers, data.channel, sandbox, version, data.status || "active", data.quoteId, purchaser, data.cancellationReason, data.cancellationAdditionalInfo, data.canceledBy, data.canceledDate, data.sanctionsChecks, data.underwriting, data.underwritingCoverageUpdates, changeHistory, data.accountId, data.claimAdjuster, (_f = data.invoicedDate) !== null && _f !== void 0 ? _f : null);
    }
    static create(partner, partnerIds, certificateNumber, insurancePurchase, payment, sandbox, quoteId, purchaser, accountId, overridePurchaseDate, version) {
        const authorizedUsers = _1.getAuthorizedUsers(insurancePurchase);
        if ((purchaser === null || purchaser === void 0 ? void 0 : purchaser.email) && !authorizedUsers.includes(purchaser.email)) {
            authorizedUsers.push(purchaser.email);
        }
        const purchaseDate = overridePurchaseDate || date_fns_1.formatISO(new Date());
        const claimsBackOfficeDate = utils_1.getDate("2023-11-01");
        const certificatePickupDate = utils_1.getDate(insurancePurchase.shipment.pickupDate);
        let claimAdjuster;
        if (date_fns_1.isAfter(certificatePickupDate, claimsBackOfficeDate)) {
            claimAdjuster = "Vitesse";
        }
        else {
            claimAdjuster = "Raphael & Associates";
        }
        return new InsuranceCertificate(partner, certificateNumber, purchaseDate, insurancePurchase.user, insurancePurchase.coverage, insurancePurchase.assured, insurancePurchase.shipment, payment, partnerIds, authorizedUsers, insurancePurchase.channel, sandbox !== null && sandbox !== void 0 ? sandbox : partner_1.isSandboxPartner(partner.id), version !== null && version !== void 0 ? version : this.lastVersion, _1.eInsuranceCertificateStatus.active, quoteId, purchaser, undefined, undefined, undefined, undefined, undefined, insurancePurchase.underwriting, undefined, undefined, accountId, claimAdjuster, null);
    }
    getFileClaimUrl(baseUrl) {
        return `${baseUrl}/claims/file?id=${this.certificateNumber}`;
    }
    getDetailsUrl(baseUrl) {
        return `${baseUrl}/certificates/details?certificateNumber=${this.certificateNumber}`;
    }
    getDetails(baseUrl) {
        const purchasedDateISO = this.purchasedDate
            ? date_fns_1.format(date_fns_1.parseISO(this.purchasedDate), "yyyy-MM-dd 'at' ppp")
            : "unknown";
        const invoicedDateISO = this.invoicedDate
            ? date_fns_1.format(date_fns_1.parseISO(this.invoicedDate), "yyyy-MM-dd 'at' ppp")
            : "unknown";
        const { canceledBy, cancellationAdditionalInfo, cancellationReason, status, certificateNumber } = this;
        const fileClaimUrl = this.getFileClaimUrl(baseUrl !== null && baseUrl !== void 0 ? baseUrl : "");
        const certificateDetailsURL = this.getDetailsUrl(baseUrl !== null && baseUrl !== void 0 ? baseUrl : "");
        const canceledDateISO = this.canceledDate
            ? date_fns_1.format(date_fns_1.parseISO(this.canceledDate), "yyyy-MM-dd 'at' ppp")
            : "unknown";
        const carrier = this.shipment.carriers[0];
        const equipmentType = supportData_1.allEquipmentTypes()[carrier.equipmentType];
        const { otherEquipmentType } = carrier;
        const changeHistory = Array.isArray(this.changeHistory)
            ? this.changeHistory
            : [];
        const effectiveStartDate = date_fns_1.parseISO(this.shipment.pickupDate);
        const effectiveEndDate = date_fns_1.addDays(effectiveStartDate, this.coverage.daysBetweenPickupAndDelivery);
        return Object.assign(Object.assign({}, _1.getShipmentCoverageDetails(this)), { purchasedDate: purchasedDateISO, invoicedDate: invoicedDateISO, effectiveStartDate: utils_1.dateToString(effectiveStartDate), effectiveEndDate: utils_1.dateToString(effectiveEndDate), certificateNumber,
            fileClaimUrl,
            certificateDetailsURL,
            status,
            cancellationReason,
            cancellationAdditionalInfo,
            canceledBy, canceledDate: canceledDateISO, equipmentType,
            otherEquipmentType,
            changeHistory });
    }
    getSummary() {
        return {
            certificateNumber: this.certificateNumber,
            productId: this.coverage.id,
            productName: this.coverage.name,
            limit: this.coverage.limit,
            deductible: this.coverage.deductible
        };
    }
    static getCertificatePdfFilenameFromNumber(certificateNumber) {
        return `Loadsure - Insurance Certificate - ${certificateNumber}.pdf`;
    }
    static getCertificatePdfApiPathFromNumber(certificateNumber) {
        return `/insuranceCertificates/${certificateNumber}/${InsuranceCertificate.getCertificatePdfFilenameFromNumber(certificateNumber)}`;
    }
    static getCertificateOtherFilesApiPathFromNumber(certificateNumber) {
        return `/certificates/${certificateNumber}/files`;
    }
    get certificatePdfFilename() {
        return InsuranceCertificate.getCertificatePdfFilenameFromNumber(this.certificateNumber);
    }
    get certificatePdfApiPath() {
        return InsuranceCertificate.getCertificatePdfApiPathFromNumber(this.certificateNumber);
    }
    getAddressByStopType(type) {
        const stop = this.shipment.stops.find((aStop) => aStop.stopType === type);
        const address = stop === null || stop === void 0 ? void 0 : stop.address;
        const addressClass = new address_1.default(address === null || address === void 0 ? void 0 : address.address1, address === null || address === void 0 ? void 0 : address.city, address === null || address === void 0 ? void 0 : address.state, address === null || address === void 0 ? void 0 : address.postal, address === null || address === void 0 ? void 0 : address.country);
        return addressClass === null || addressClass === void 0 ? void 0 : addressClass.shortAddress;
    }
    validatePaymentTypeToCancel(isPortalAdmin, action = "cancel") {
        const { payment } = this;
        if (payment instanceof payments_1.CreditCardPayment) {
            if (isPortalAdmin && action === "cancel") {
                if (!payment.transactionId) {
                    return new _1.ActionAllowed(`Cannot ${action} certificate, CC transaction id not found`);
                }
            }
            else {
                return new _1.ActionAllowed(`Cannot ${action} certificate, certificate was purchased by credit card`);
            }
        }
        return undefined;
    }
    validatePickupCutoffDate(cancelDate) {
        const { shipment: { pickupDate: pickupDateISO, deliveryDate: deliveryDateISO } } = this;
        const cancelDateStr = date_fns_1.formatISO(cancelDate).substring(0, 10);
        const pickupDateStr = pickupDateISO.substring(0, 10);
        if (pickupDateStr > cancelDateStr) {
            return undefined;
        }
        if (pickupDateStr === cancelDateStr) {
            const deliveryDateStr = deliveryDateISO.substring(0, 10);
            if (deliveryDateStr > cancelDateStr) {
                return undefined;
            }
            return new _1.ActionAllowed("Certificate delivery date must be in the future");
        }
        return new _1.ActionAllowed("Certificate pickup date cannot be in the past");
    }
    validatePurchaseCutoffDate(cancelDate) {
        const { purchasedDate } = this;
        const purchaseCutoffDate = date_fns_1.addDays(date_fns_1.lastDayOfMonth(date_fns_1.parseISO(purchasedDate)), 7);
        const pastPurchaseCutoff = date_fns_1.isAfter(cancelDate, purchaseCutoffDate);
        if (pastPurchaseCutoff) {
            const dateFormatted = date_fns_1.formatISO(purchaseCutoffDate).substring(0, 10);
            return new _1.ActionAllowed(`Certificate purchase date past cutoff ${dateFormatted}`);
        }
        return undefined;
    }
    cancelable(isLoadsureAdmin, cancelDate = new Date()) {
        const { status } = this;
        const certificateInactive = !(status === undefined || status === _1.eInsuranceCertificateStatus.active);
        if (certificateInactive) {
            return new _1.ActionAllowed("Certificate has already been cancelled");
        }
        return (this.validatePaymentTypeToCancel(isLoadsureAdmin, "cancel") ||
            (!isLoadsureAdmin && this.validatePickupCutoffDate(cancelDate)) ||
            this.validatePurchaseCutoffDate(cancelDate) ||
            new _1.ActionAllowed());
    }
    isEditable(isLoadsureAdmin) {
        const someStopInPast = this.shipment.stops.some((stop) => {
            if (stop.date)
                return date_fns_1.isPast(date_fns_1.endOfDay(utils_1.getDate(stop === null || stop === void 0 ? void 0 : stop.date)));
            return false;
        });
        if (!this.isActive ||
            !isLoadsureAdmin ||
            date_fns_1.isPast(date_fns_1.endOfDay(utils_1.getDate(this.shipment.deliveryDate)))) {
            return new _1.ActionAllowed(JSON.stringify({
                active: this.isActive,
                isLoadsureAdmin,
                stopInPast: someStopInPast
            }));
        }
        return new _1.ActionAllowed();
    }
    isRestorable(isPortalAdmin, cancelDate = new Date()) {
        const { status } = this;
        if (!isPortalAdmin) {
            return new _1.ActionAllowed("The certificate only can be restored by portal admin users");
        }
        const certificateCancelled = status === undefined || status === _1.eInsuranceCertificateStatus.cancelled;
        if (!certificateCancelled) {
            return new _1.ActionAllowed("The certificate must be canceled to be restored");
        }
        const paymentValidation = this.validatePaymentTypeToCancel(isPortalAdmin, "restore");
        if (paymentValidation) {
            return paymentValidation;
        }
        const pickupDateValidation = this.validatePickupCutoffDate(cancelDate);
        if (pickupDateValidation) {
            return pickupDateValidation;
        }
        const purchaseDateValidation = this.validatePurchaseCutoffDate(cancelDate);
        if (purchaseDateValidation) {
            return purchaseDateValidation;
        }
        return new _1.ActionAllowed();
    }
    get isActive() {
        return this.status !== _1.eInsuranceCertificateStatus.cancelled;
    }
    addRegisterToChangeHistory(newChanges) {
        if (Array.isArray(this.changeHistory)) {
            this.changeHistory.push(newChanges);
        }
        else {
            this.changeHistory = [newChanges];
        }
        return this.changeHistory;
    }
}
exports.default = InsuranceCertificate;
InsuranceCertificate.lastVersion = 6;
//# sourceMappingURL=insuranceCertificate.class.js.map